import { render, staticRenderFns } from "./page-attribution.vue?vue&type=template&id=d8648490&"
import script from "./page-attribution.vue?vue&type=script&lang=js&"
export * from "./page-attribution.vue?vue&type=script&lang=js&"
import style0 from "./page-attribution.vue?vue&type=style&index=0&id=d8648490&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports